<template>
  <span class="badge sync-badge" :class="itemClass" v-text="$t(label)" :title="tooltip"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SyncBadge',
  props: {
    flag: { type: Boolean, default: null },
    readOnly: { type: Boolean, default: false },
  },
  computed: {
    itemClass() {
      if (this.readOnly) return 'bg-secondary';
      if (this.flag === null) return 'bg-danger';
      return this.flag ? 'bg-success' : 'bg-warning';
    },
    label() {
      if (this.flag === null) return 'adm.label.syncFlags.unknown';
      return this.flag ? 'adm.label.syncFlags.active' : 'adm.label.syncFlags.inactive';
    },
    tooltip() {
      return this.readOnly ? 'read-only' : '';
    }
  },
});
</script>

<style>
:root {
  --stihl-sync-badge-height: 1rem;
}

.sync-badge {
  max-height: var(--stihl-sync-badge-height);
  padding-bottom: 1px; /* correct centering */
}
</style>
